import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React from 'react'
import type { Component } from 'types/components'

interface ArchiveConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  selectedComponents: Component[]
  action: 'archive' | 'unarchive'
  organizationLabelMap: Record<string, string>
}

const ArchiveConfirmationDialog: React.FC<ArchiveConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedComponents,
  action,
  organizationLabelMap,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Confirm {action === 'archive' ? 'Archive' : 'Unarchive'}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          You are about to {action} {selectedComponents.length} component
          {selectedComponents.length !== 1 ? 's' : ''}. Please review the items below and confirm your action.
        </Typography>
        <TableContainer sx={{ mt: 3, maxHeight: 400 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Name</strong>
                </TableCell>
                <TableCell>
                  <strong>Team</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedComponents.map((component, idx) => (
                <TableRow key={component.id || idx}>
                  <TableCell>{component.label}</TableCell>
                  <TableCell>{organizationLabelMap[component.organizationId] || component.organizationId}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color={action === 'archive' ? 'warning' : 'primary'}>
          {action === 'archive' ? 'Archive' : 'Unarchive'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ArchiveConfirmationDialog
